import { Injectable } from '@angular/core';

declare global {
  interface Window {
    plausible?: (eventName: string, options?: { callback?: () => void }) => void;
  }
}

@Injectable({
  providedIn: 'root'
})
export class PlausibleService {

  trackClick = (event: MouseEvent, eventName: string) => {
    if (typeof window === 'undefined' || typeof window.plausible !== 'function') {
      return; // SSR, or Plausible script blocked/not loaded — let the default navigation happen
    }

    const anchor = event.currentTarget as HTMLAnchorElement;

    if (anchor.target === '_blank') {
      window.plausible(eventName);
      return;
    }

    event.preventDefault();
    let navigated = false;
    const navigate = () => {
      if (navigated) return;
      navigated = true;
      window.location.href = anchor.href;
    };

    window.plausible(eventName, { callback: navigate });
    setTimeout(navigate, 300); // fallback in case the callback never fires
  }
}
